import * as React from 'react';

import { ClickTracker } from 'bernie-analytics';

import { FilterOptionModel } from './filter-types';

import { UitkCheckbox } from 'uitk-react-switch';

export interface CheckboxInputProps extends FilterOptionModel {
  index?: number;
  checked?: boolean;
  handleClick?: (Event) => void;
  handleChange?: (Event) => void;
  firstIndex?: number;
  lastIndex?: number;
  description?: string;
  isRange?: boolean;
  filterType?: string;
}

const CheckboxTracked = ClickTracker(UitkCheckbox);

export class CheckboxInput extends React.Component<CheckboxInputProps> {
  private handleChange = event => {
    const { handleChange, name, value, filterType } = this.props;
    const target = event.target;
    const { checked } = target;
    if (typeof handleChange === 'function') {
      handleChange({
        target: {
          name,
          value,
          checked,
          filterType,
        },
      });
    }
  };

  public render() {
    const { checked, index, label, description, name, value, firstIndex, lastIndex, isRange, filterType, ariaLabel } = this.props;
    const oneBasedIndex = index + 1;
    const checkboxAttributes = {
      id: `${name}-${index}-${value}`,
      key: `${name}-${index}-${value}`,
      name,
      value,
      checked,
      onChange: this.handleChange,
      label,
      description,
      disabled: false,
    };

    if (isRange && index > firstIndex && index < lastIndex) {
      checkboxAttributes.disabled = true;
      checkboxAttributes.checked = true;
    }

    const categoryStr = `${filterType ? `.${filterType}` : ''}`;

    return (
      <CheckboxTracked
        events="click"
        aria-label={ariaLabel}
        key={checkboxAttributes.id}
        linkName={`${name}.${value}`}
        rfrr={`${name}${categoryStr}.${value}.${!checked}:${oneBasedIndex}`}
        {...checkboxAttributes}
      />
    );
  }
}
